import "core-js/modules/es.array.reverse.js";
var _dec, _dec2, _class, _descriptor, _descriptor2, _dec3, _class2, _descriptor3, _dec4, _dec5, _dec6, _dec7, _class3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _dec8, _dec9, _dec0, _class4, _descriptor8, _descriptor9, _descriptor0, _dec1, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _class5, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import i18next from "i18next";
import anyTrait from "../Decorators/anyTrait";
import objectArrayTrait from "../Decorators/objectArrayTrait";
import primitiveArrayTrait from "../Decorators/primitiveArrayTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import ModelTraits from "../ModelTraits";
import mixTraits from "../mixTraits";
import EnumDimensionTraits from "./DimensionTraits";
export let MetadataUrlTraits = (_dec = primitiveTrait({
  type: "string",
  name: "URL",
  description: "The metadata URL of the file or service."
}), _dec2 = primitiveTrait({
  type: "string",
  name: "Title",
  description: "Title used for metadata URL button."
}), _class = class MetadataUrlTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "url", _descriptor, this);
    _initializerDefineProperty(this, "title", _descriptor2, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "url", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "title", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export let DataUrlTraits = (_dec3 = primitiveTrait({
  type: "string",
  name: "Type",
  description: "Type of data URL. This value will be used to provide context or instruction on how to use the data URL. For example `wcs` will provide a link to WCS docs.\n    Current supported values are:\n    - `wfs` = A Web Feature Service (WFS) base URL\n    - `wcs` = A Web Coverage Service (WCS) base URL\n    - `wfs-complete` = A complete, ready-to-use link to download features from a WCS server\n    -  `wcs-complete` = A complete, ready-to-use link to download features from a WFS server\n    -  `direct` = Direct URL to dataset (this is the default if no `type` is specified)\n    -  `none` = Hide data URL\n    "
}), _class2 = class DataUrlTraits extends mixTraits(MetadataUrlTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "type", _descriptor3, this);
  }
}, _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "type", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2);
export let InfoSectionTraits = (_dec4 = primitiveTrait({
  type: "string",
  name: "Name",
  description: "The name of the section."
}), _dec5 = primitiveTrait({
  type: "string",
  name: "Content",
  description: "The content of the section, in Markdown and HTML format. Set this property to null to remove this section entirely.",
  isNullable: true
}), _dec6 = anyTrait({
  name: "Content As Object",
  description: "The content of the section which is a JSON object. Set this property to null to remove this section entirely."
}), _dec7 = primitiveTrait({
  type: "boolean",
  name: "Show",
  description: "Indicates if this info section showing (not collapsed)."
}), _class3 = class InfoSectionTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "name", _descriptor4, this);
    _initializerDefineProperty(this, "content", _descriptor5, this);
    _initializerDefineProperty(this, "contentAsObject", _descriptor6, this);
    _initializerDefineProperty(this, "show", _descriptor7, this);
  }
  static isRemoval(infoSection) {
    return infoSection.content === null;
  }
}, _descriptor4 = _applyDecoratedDescriptor(_class3.prototype, "name", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class3.prototype, "content", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class3.prototype, "contentAsObject", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class3.prototype, "show", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _class3);
export let ShortReportTraits = (_dec8 = primitiveTrait({
  type: "string",
  name: "Name",
  description: "The name of the section."
}), _dec9 = primitiveTrait({
  type: "string",
  name: "Content",
  description: "The content of the section."
}), _dec0 = primitiveTrait({
  type: "boolean",
  name: "Show",
  description: "Indicates if this short report section showing."
}), _class4 = class ShortReportTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "name", _descriptor8, this);
    _initializerDefineProperty(this, "content", _descriptor9, this);
    _initializerDefineProperty(this, "show", _descriptor0, this);
  }
}, _descriptor8 = _applyDecoratedDescriptor(_class4.prototype, "name", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class4.prototype, "content", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class4.prototype, "show", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _class4);

/* eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging */
let CatalogMemberTraits = (_dec1 = primitiveTrait({
  type: "string",
  name: "Name",
  description: "The name of the catalog item."
}), _dec10 = primitiveTrait({
  type: "string",
  name: "Description",
  description: "The description of the catalog item. Markdown and HTML may be used."
}), _dec11 = primitiveTrait({
  type: "boolean",
  name: "Hide default description",
  description: "If true, then no generic default description will be displayed if `description` is undefined."
}), _dec12 = primitiveTrait({
  type: "string",
  name: "Name in catalog",
  description: "The name of the item to be displayed in the catalog, if it is different from the one to display in the workbench."
}), _dec13 = objectArrayTrait({
  type: InfoSectionTraits,
  name: "Info",
  description: "Human-readable information about this dataset.",
  idProperty: "name"
}), _dec14 = primitiveArrayTrait({
  type: "string",
  name: "InfoSectionOrder",
  description: "An array of section titles defining the display order of info sections. If this property is not defined, {@link DataPreviewSections}'s DEFAULT_SECTION_ORDER is used"
}), _dec15 = primitiveTrait({
  type: "boolean",
  name: "Is catalog item open in workbench",
  description: "Whether the item in the workbench open or collapsed."
}), _dec16 = primitiveTrait({
  type: "string",
  name: "Short report",
  description: "A short report to show on the now viewing tab."
}), _dec17 = objectArrayTrait({
  type: ShortReportTraits,
  idProperty: "name",
  name: "Short report sections",
  description: "A list of collapsible sections of the short report"
}), _dec18 = primitiveTrait({
  type: "boolean",
  name: "Is experiencing issues",
  description: "Whether the catalog item is experiencing issues which may cause its data to be unavailable"
}), _dec19 = primitiveTrait({
  type: "boolean",
  name: "Hide source in explorer window",
  description: "Indicates that the source of this data should be hidden from the UI (obviously this isn't super-secure as you can just look at the network requests)."
}), _dec20 = objectArrayTrait({
  type: MetadataUrlTraits,
  name: "Metadata URLs",
  description: "Metadata URLs to show in data catalog.",
  idProperty: "index"
}), _dec21 = objectArrayTrait({
  type: DataUrlTraits,
  name: "Data URLs",
  description: "Data URLs to show in data catalog.",
  idProperty: "index"
}), _dec22 = primitiveTrait({
  name: "Data Custodian",
  type: "string",
  description: "Gets or sets a description of the custodian of this data item."
}), _dec23 = objectArrayTrait({
  type: EnumDimensionTraits,
  idProperty: "id",
  name: "Model dimensions",
  description: "This provides ability to set model JSON through SelectableDimensions (a dropdown). When an option is selected, the `value` property will be used to call `updateModelFromJson()`. All string properties support Mustache templates (with the catalog member as context)"
}), _dec24 = primitiveTrait({
  type: "boolean",
  name: "Disable about data",
  description: "Disables the 'About Data' button in the workbench."
}), _dec25 = primitiveTrait({
  type: "boolean",
  name: "Shareable",
  description: "True (default) if this catalog member may be included in share links. False to exclude it from share links."
}), _dec26 = anyTrait({
  name: "Workbench controls",
  description: "Flags for enabling or disabling workbench controls."
}), _class5 = class CatalogMemberTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "hideDefaultDescription", _descriptor1, this);
    _initializerDefineProperty(this, "info", _descriptor10, this);
    _initializerDefineProperty(this, "infoSectionOrder", _descriptor11, this);
    _initializerDefineProperty(this, "isOpenInWorkbench", _descriptor12, this);
    _initializerDefineProperty(this, "shortReportSections", _descriptor13, this);
    _initializerDefineProperty(this, "isExperiencingIssues", _descriptor14, this);
    _initializerDefineProperty(this, "hideSource", _descriptor15, this);
    _initializerDefineProperty(this, "metadataUrls", _descriptor16, this);
    _initializerDefineProperty(this, "dataUrls", _descriptor17, this);
    _initializerDefineProperty(this, "dataCustodian", _descriptor18, this);
    _initializerDefineProperty(this, "modelDimensions", _descriptor19, this);
    _initializerDefineProperty(this, "shareable", _descriptor20, this);
    _initializerDefineProperty(this, "workbenchControlFlags", _descriptor21, this);
  }
  get name() {
    return;
  }
  get description() {
    return;
  }
  get nameInCatalog() {
    return;
  }
  get shortReport() {
    return;
  }
  get disableAboutData() {
    return;
  }
}, _applyDecoratedDescriptor(_class5.prototype, "name", [_dec1], Object.getOwnPropertyDescriptor(_class5.prototype, "name"), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, "description", [_dec10], Object.getOwnPropertyDescriptor(_class5.prototype, "description"), _class5.prototype), _descriptor1 = _applyDecoratedDescriptor(_class5.prototype, "hideDefaultDescription", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class5.prototype, "nameInCatalog", [_dec12], Object.getOwnPropertyDescriptor(_class5.prototype, "nameInCatalog"), _class5.prototype), _descriptor10 = _applyDecoratedDescriptor(_class5.prototype, "info", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class5.prototype, "infoSectionOrder", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [i18next.t("preview.disclaimer"), i18next.t("description.name"), i18next.t("preview.dataDescription"), i18next.t("preview.datasetDescription"), i18next.t("preview.serviceDescription"), i18next.t("preview.resourceDescription"), i18next.t("preview.licence"), i18next.t("preview.accessConstraints"), i18next.t("preview.author"), i18next.t("preview.contact"), i18next.t("preview.created"), i18next.t("preview.modified"), i18next.t("preview.updateFrequency")];
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class5.prototype, "isOpenInWorkbench", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _applyDecoratedDescriptor(_class5.prototype, "shortReport", [_dec16], Object.getOwnPropertyDescriptor(_class5.prototype, "shortReport"), _class5.prototype), _descriptor13 = _applyDecoratedDescriptor(_class5.prototype, "shortReportSections", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class5.prototype, "isExperiencingIssues", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class5.prototype, "hideSource", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class5.prototype, "metadataUrls", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class5.prototype, "dataUrls", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class5.prototype, "dataCustodian", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class5.prototype, "modelDimensions", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class5.prototype, "disableAboutData", [_dec24], Object.getOwnPropertyDescriptor(_class5.prototype, "disableAboutData"), _class5.prototype), _descriptor20 = _applyDecoratedDescriptor(_class5.prototype, "shareable", [_dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class5.prototype, "workbenchControlFlags", [_dec26], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class5);
/* eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging */
export default CatalogMemberTraits;